module.exports = __webpack_public_path__ + "img/Сursor.716b3b2f.svg";